import * as React from 'react';
import { Tooltip } from '../../primitives';
import { Column, FloaterMenu, Icon, iconsMap, MenuItem, Popover, Row, Text } from '../..';
import { classNames } from '@wix/answers-lib';
import { compKey } from './key';
import { namespacedClassnames } from '../../common';
import { LibColor } from '../../new-libby';
import { MenuItemDivider, MenuItemSubtitle } from '../../composites';
export var PopoverSelect = function (props) {
    var _a = React.useState(false), isPopoverOpen = _a[0], setIsPopoverOpen = _a[1];
    var isExtendedOption = function (option) {
        return option.value !== undefined;
    };
    var onSelect = function (option) { return function () {
        var selectedOption = isExtendedOption(option) ? option.value : option;
        setIsPopoverOpen(false);
        return props.onChange(selectedOption);
    }; };
    var menuItems = props.options.map(function (option, idx) {
        var maybeExtededOption = isExtendedOption(option) ? option : null;
        var optionValue = maybeExtededOption ? maybeExtededOption.value : option;
        var menuItem = (React.createElement(MenuItem, { value: "" + optionValue, className: classNames('popover-select-option', { selected: optionValue === props.value }), onSelect: onSelect(optionValue) }, props.renderOption(optionValue)));
        var maybeDivider = (maybeExtededOption === null || maybeExtededOption === void 0 ? void 0 : maybeExtededOption.divider) ?
            React.createElement(MenuItemDivider, { className: classNames("menu-divider-item-" + idx) }) : null;
        var maybeSubtitle = (maybeExtededOption === null || maybeExtededOption === void 0 ? void 0 : maybeExtededOption.subtitle) ?
            React.createElement(MenuItemSubtitle, { className: classNames("menu-subtitle-item-" + idx) }, maybeExtededOption.subtitle) : null;
        return (React.createElement(React.Fragment, null,
            maybeDivider,
            maybeSubtitle,
            menuItem));
    });
    var popoverBody = (React.createElement("div", { className: 'popover-menu-wrapper' },
        React.createElement(FloaterMenu, { className: 'popover-floater-menu' }, menuItems)));
    var selectedValueText = props.renderValue ? props.renderValue(props.value) : (React.createElement(Text, { color: props.disabled ? 't50' : 't60', className: 'selected-option-title', type: 'hxsm' }, props.renderOption(props.value)));
    var selectedValue = props.disabled ? (React.createElement(Tooltip, { body: props.disabled, relativeToBody: true, direction: 'top', align: 'left' }, selectedValueText)) : selectedValueText;
    var onClick = !props.disabled ? function () { return setIsPopoverOpen(true); } : undefined;
    var closePopover = function () { return setIsPopoverOpen(false); };
    var classes = classNames('popover-select-menu-wrapper', props.className);
    var popoverSelect = (React.createElement(Popover, { className: classes, body: popoverBody, isOpen: isPopoverOpen, onOuterAction: closePopover, bringToFront: props.bringToFront },
        React.createElement("div", { className: namespacedClassnames(compKey, { 'left-border': props.leftBorder && !props.title }), onClick: onClick },
            React.createElement(Row, { gap: '4', verticalAlignment: 'center', className: classNames('inner-popover-select', { disabled: !!props.disabled }) },
                selectedValue,
                React.createElement(Icon, { className: 'arrow-icon', icon: iconsMap.dropDownToggle, color: props.disabled ? LibColor.grey100 : undefined })))));
    return props.title ? (React.createElement(Column, { className: classNames('popover-select-title-wrapper', props.className, { 'left-border': props.leftBorder }), gap: '2' },
        React.createElement(Text, { className: 'popover-select-title', type: 'ht', color: 't40' }, props.title),
        popoverSelect)) : popoverSelect;
};
//# sourceMappingURL=index.js.map